let listeners = [];

export const toast = {
  subscribe(listener) {
    listeners.push(listener);
    return () => {
      listeners = listeners.filter((l) => l !== listener);
    };
  },
  show(title, message, type = "info", duration = 4000) {
    const id = Math.random().toString(36).substring(2, 9);
    listeners.forEach((listener) =>
      listener({ id, title, message, type, duration })
    );
    return id;
  },
  success(title, message, duration) {
    return this.show(title, message, "success", duration);
  },
  error(title, message, duration) {
    return this.show(title, message, "error", duration);
  },
  warning(title, message, duration) {
    return this.show(title, message, "warning", duration);
  },
  info(title, message, duration) {
    return this.show(title, message, "info", duration);
  },
};
